// frontend/src/HomePage.js
import React from 'react';
import './HomePage.css'; // Assuming CSS exists
import ProtectedElement from './ProtectedElement';

function HomePage({ navigateToExplorer, navigateToChat, navigateToConfig, navigateToDataManagement, navigateToPolicyBot, navigateToPipeline, authUsername, theme }) {
    return (
        <div className={`home-page-container ${theme === 'LIGHT' ? 'theme-light' : 'theme-dark'}`}>
            <section className="home-hero">
            <div className="home-page-logo-container">
                <img
                    src={`${process.env.PUBLIC_URL}/Pearlify-logo.png`}
                    alt="Pearlify logo"
                    className="home-page-logo"
                />
                <img
                    src={`${process.env.PUBLIC_URL}/Pearlify-text.png`}
                    alt="Pearlify text"
                    className="home-page-logo-text"
                />
            </div>
            <header className="home-page-header">
                {/* UPDATED App Name */}
                <h1>
                    Welcome to{' '}
                    <img
                        src={`${process.env.PUBLIC_URL}/Pearlify-text.png`}
                        alt="Pearlify"
                        className="home-page-wordmark"
                    />
                    {`, ${authUsername}!`}
                </h1>
                <p>Your central hub for knowledge exploration and interaction.</p>
            </header>
            </section>
            <nav className="home-navigation">
                <h2>Choose Your Tool:</h2>
                <div className="nav-options">
                    <button onClick={navigateToChat} className="nav-option-button chat">
                         <div className="nav-option-icon">💬</div>
                        <h3>Intelligent Chat</h3>
                        <p>Engage in conversations using various AI models and tools.</p>
                    </button>
                    <ProtectedElement required="page:data-management-access" behavior='hide'>
                        <button onClick={navigateToDataManagement} className="nav-option-button data">
                            <div className="nav-option-icon">🗂️</div>
                            <h3>Data Management</h3>
                            <p>View and review ingested files, columns, and knowledge graphs.</p>
                        </button>
                    </ProtectedElement>
                    <ProtectedElement required="page:policy-bot-access" behavior='hide'>
                        <button onClick={navigateToPolicyBot} className="nav-option-button policyBot">
                            <div className="nav-option-icon">🤖</div>
                            <h3>Policy Bot</h3>
                            <p>Interact with the policy bot for guidance and support.</p>
                        </button>
                    </ProtectedElement>
                    <ProtectedElement required="page:pipeline-access" behavior='hide'>
                        <button onClick={navigateToPipeline} className="nav-option-button pipeline">
                            <div className="nav-option-icon">🧪</div>
                            <h3>Pipeline Runner</h3>
                            <p>Run a dedicated multi-step prompt pipeline and review outputs.</p>
                        </button>
                    </ProtectedElement>
                    <ProtectedElement required="page:kn-explorer-access" behavior='hide'>
                        <button onClick={navigateToExplorer} className="nav-option-button explorer">
                            <div className="nav-option-icon">🧭</div>
                            <h3>Knowledge Explorer</h3>
                            <p>Visually explore connected concepts and research findings.</p>
                        </button>
                    </ProtectedElement>
                    <button onClick={navigateToConfig} className="nav-option-button config">
                        <div className="nav-option-icon">⚙️</div>
                        <h3>Configuration</h3>
                        <p>Manage data sources, prompts, pipelines, and settings.</p>
                    </button>
                </div>
            </nav>
            <footer className="home-page-footer">
                <p>Select an option above to begin.</p>
            </footer>
        </div>
    );
}

export default HomePage;